module.exports = "/packs/images/homepage/facilities/leisure_mobile~068d599afb5088f780ec604a7ceeb180.jpg";